import RichText from './RichText';
import jQuery from 'jquery';
export default class DynamicRichText {
    constructor(section) {
        this.$el = jQuery(section.el);
        this.rte = [];
        this.$el.find('[data-rte]').each((i, el) => {
            this.rte.push(new RichText(jQuery(el)));
        });
    }
    /**
     * Unbind events when section is re-drawn
     */
    onSectionUnload() {
        this.rte.forEach((richTextArea) => {
            richTextArea.unload();
        });
    }
}
